export interface ApiScope {
  name: string;
  description: string;
  link: string;
}

export const scopes: ApiScope[] = [
  {
    name: 'API.acceptedAssets',
    description: 'API.acceptedAssetsDescription',
    link: '/AcceptedAsset',
  },
  {
    name: 'API.accountCreation',
    description: 'API.accountCreationDescription',
    link: '/AccountCreation/post_api_public_AccountCreation_create_subaccount',
  },
  {
    name: 'API.paymentReport',
    description: 'API.paymentReportDescription',
    link: '/PaymentReport',
  },
  {
    name: 'API.paymentRequestPublicApi',
    description: 'API.paymentRequestPublicApiDescription',
    link: '/PaymentRequestPublicApi',
  },
  {
    name: 'API.webhookApi',
    description: 'API.webhookApiDescription',
    link: '/WebHookApi',
  },
  // {
  //   name: 'API.conversionRate',
  //   description: 'API.conversionRateDescription',
  //   link: '/ConversionRate'
  // },
];
